/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8.05.24
 *
 */
import FormItem from "@/core/modules/coach/Resources/Forms/model/FormItem.js";
import FormElementTitle from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/FormElementTitle.js";
import FormElementCheckboxes
	from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementCheckboxes.js";
import FormElementScoreResult
	from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/FormElementScoreResult.js";

export const ATTACHMENT_QUIZ_FORM_ID = 'attachment_quiz';

let attachmentQuizFormItem

export function getAttachmentQuizForm(){
	return getPredefinedFormById(ATTACHMENT_QUIZ_FORM_ID)
}

export function getPredefinedFormById(formId){
	switch (formId) {
		case ATTACHMENT_QUIZ_FORM_ID:
			return attachmentQuizFormItem
		default:
			return null
	}

}

function setupForms(){
	setupAttachmentQuiz()

}

function setupAttachmentQuiz(){
	let form = new FormItem()
	form.id = ATTACHMENT_QUIZ_FORM_ID
	form.settings.showSingleQuestionPerPage = true
	form.settings.showResultAfterCompletion = true
	form.settings.collectNameAndEmailAfterSubmit = true
	form.settings.collectName = true
	form.settings.collectEmail = true
	form.isEditable = false
	form.title = 'Attachment Style Quiz'

	// We need to first sync elements from settings before calling form.addElement()
	// since form.addElement() internally calls form.syncSettingsFromFormElements()
	// which overrides the settings
	form.syncFormElementsFromSettings()

	form.addElement(new FormElementTitle(form.title, 'Welcome!  \n' +
		'\n' +
		'This quiz is meant to guide you into a gentle and self-compassionate way of understanding attachment.\n' +
		'\n' +
		'For the most accurate results, choose just ONE close relationship to keep in mind as you answer each question, and keep that same person in mind throughout.\n' +
		'\n' +
		'Many questions are about partnership. If you aren\'t partnered, a best friend, sibling, or someone with whom you are intimate can stand in where the word partner appears.'))


	form.addElement(
		new FormElementScoreResult()
			.clearOptions()
			.setResultAsPercentage(true)
			.setResultAsBuckets(true)
			.addRange("Secure/Earned Secure Attachment")
			.addRange("Ambivalent/Anxious Attachment")
			.addRange("Avoidant Attachment")
			.addRange("Disorganised Attachment")
	)

	form.addElement(
		new FormElementCheckboxes("I wake up liking myself", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("Most of the time", "4/#ans")
			.addAnswerOption("Sometimes", "4/#ans")
			.addAnswerOption("I don't think about it", "4/#ans")
			.addAnswerOption("Never", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When things are hard I", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("Reach out for help", "4/#ans")
			.addAnswerOption("Melt down for a while, have a hard time moving forward, then do my best to keep going", "4/#ans")
			.addAnswerOption("Work harder OR withdraw (or both)", "4/#ans")
			.addAnswerOption("Hurt myself or others, physically or emotionally, OR dissociate", "4/#ans")
	).addElement(
		new FormElementCheckboxes("I believe that people who know me can feel genuine affection for me.", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("I believe this most of the time", "4/#ans")
			.addAnswerOption("I believe this sometimes", "4/#ans")
			.addAnswerOption("I don't think about it", "4/#ans")
			.addAnswerOption("I believe this rarely", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When I'm talking with people in casual conversation, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("most often both share my own experience and ask about theirs", "4/#ans")
			.addAnswerOption("often I am caught up in emotions and/or am very curious about others' emotions", "4/#ans")
			.addAnswerOption("am most comfortable talking about myself or telling stories", "4/#ans")
			.addAnswerOption("charm people and I'm charismatic: people want me to like them, OR I feel afraid to take up space", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When I'm talking or writing in professional contexts, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("share openly, appropriate to the company and my comfort level", "4/#ans")
			.addAnswerOption("worry about what other people think too much to share openly. I usually say what I think others want to hear", "4/#ans")
			.addAnswerOption("usually just say what I think and don’t worry about it", "4/#ans")
			.addAnswerOption("tailor my expression according to what I want from the people I’m with OR self- expression is terrifying to me.", "4/#ans")
	).addElement(
		new FormElementCheckboxes("My to-do list is:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("a helpful support to my days", "4/#ans")
			.addAnswerOption("what to-do list are you talking about??", "4/#ans")
			.addAnswerOption("my entire life", "4/#ans")
			.addAnswerOption("something to beat myself up about", "4/#ans")
	).addElement(
		new FormElementCheckboxes("I prioritize my intimate connections over other experiences, that is, I choose to spend my day off with my partner or a good friend, or on self- care, rather than filling all my time with projects.", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("most of the time OR I balance my days off between intimacy with others and time with myself", "4/#ans")
			.addAnswerOption("always, even at the cost of self-care and time with myself", "4/#ans")
			.addAnswerOption("rarely OR I care for myself by watching shows or playing video games", "4/#ans")
			.addAnswerOption("I never know what I’m going to prioritize OR when my partner doesn't choose me, I feel urgency or panic", "4/#ans")
	).addElement(
		new FormElementCheckboxes("I do what I say I’m going to do:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("mostly, and I adjust agreements when needed", "4/#ans")
			.addAnswerOption("sometimes, and it’s hard for me to say no", "4/#ans")
			.addAnswerOption("almost always", "4/#ans")
			.addAnswerOption("rarely OR always feel panic or urgency if I can't", "4/#ans")
	).addElement(
		new FormElementCheckboxes("I feel afraid:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("very rarely or not very often. I have good resources to reach out to when I’m afraid ", "4/#ans")
			.addAnswerOption("often", "4/#ans")
			.addAnswerOption("I don’t think about whether I’m afraid", "4/#ans")
			.addAnswerOption("always or never", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When other people say they are sad, I", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("say something to acknowledge what they are going through", "4/#ans")
			.addAnswerOption("feel so sad for them", "4/#ans")
			.addAnswerOption("don’t really notice, change the subject, or point out how they caused it themselves.", "4/#ans")
			.addAnswerOption("sometimes I dissociate OR I become angry; sometimes I’m deeply supportive", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When other people are happy, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("celebrate with them", "4/#ans")
			.addAnswerOption("am happier for them than they are themselves", "4/#ans")
			.addAnswerOption("feel slightly uncomfortable and often help them get grounded again with reality OR I feel resentful, or a little uncomfortable because I am not happy so it’s hard to be happy for them", "4/#ans")
			.addAnswerOption("can become angry OR scared OR dissociate without real reason", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When people are angry at me, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("have a flexible, fairly calm response depending on the situation", "4/#ans")
			.addAnswerOption("get angrier OR am frightened OR sometimes I cry", "4/#ans")
			.addAnswerOption("attempt to shut them down with logic or contempt", "4/#ans")
			.addAnswerOption("have an unpredictable, sometimes frightening response OR I dissociate or feel shaky", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When someone starts speaking quickly and doing a hard sell (are pushing me to agree or trying to convince me of something), I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("leave if I want to, stay if I’m interested", "4/#ans")
			.addAnswerOption("collapse and do what’s being asked OR make friends in defense", "4/#ans")
			.addAnswerOption("don’t really notice OR shut down and endure OR become slightly irritated and defend my position", "4/#ans")
			.addAnswerOption("become confused and dissociate and/or I rage", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When my partner or good friend asks me to talk about emotions, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("feel connected and interested", "4/#ans")
			.addAnswerOption("have a lot of resentment and pain that has never been heard", "4/#ans")
			.addAnswerOption("have a sense that the time is wasted, and the conversations seem to take forever", "4/#ans")
			.addAnswerOption("can become angry and/or dissociated and confused", "4/#ans")
	).addElement(
		new FormElementCheckboxes("I feel most comfortable and secure with a partner or good friend who is:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("engaged and attentive, with periods of disengagement for rest", "4/#ans")
			.addAnswerOption("very calm and solid", "4/#ans")
			.addAnswerOption("alive, responsive to life", "4/#ans")
			.addAnswerOption("unpredictable and a little dangerous", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When discussing the personal history of our relationship with a partner or good friend, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("remember anniversaries and events with clarity", "4/#ans")
			.addAnswerOption("can tend to recall old pain", "4/#ans")
			.addAnswerOption("have a hard time remembering nuances and details", "4/#ans")
			.addAnswerOption("can become angry and/or dissociated and confused", "4/#ans")
	).addElement(
		new FormElementCheckboxes("The more intimate I become with my partner or good friend, the more I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("feel warm and close and happy and recognize my edges", "4/#ans")
			.addAnswerOption("want something that feels unattainable and/or feel like we are the same person", "4/#ans")
			.addAnswerOption("fear losing myself and/or am afraid of getting too close", "4/#ans")
			.addAnswerOption("dissociate and/or become unpredictable, terrified, or terrifying", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When something is promised and my partner or good friend doesn’t follow through, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("ask my partner or good friend what happened and come up with a different strategy", "4/#ans")
			.addAnswerOption("make excuses for my partner or good friend and/or lose my temper and/or have a sense of abandonment", "4/#ans")
			.addAnswerOption("know that I am right and the other is wrong and I judge and blame and express contempt", "4/#ans")
			.addAnswerOption("respond with emotional or physical violence and/or with dissociation or self-harm", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When someone who is not my partner or good friend expresses love and affection, I feel:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("warm and happy. I can easily express love and affection in return", "4/#ans")
			.addAnswerOption("anxious, doubtful that it’s true and/or indebted", "4/#ans")
			.addAnswerOption("uncomfortable. And it’s hard to say it back", "4/#ans")
			.addAnswerOption("either satisfied that I have the power I need and/or terrified", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When I’m asked how I feel by people who are important to me, I’m most likely to answer:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("with emotion, words, and some understanding of why I feel the way I do", "4/#ans")
			.addAnswerOption("with my best guess of the emotions I am having that are most similar to the person who is asking", "4/#ans")
			.addAnswerOption("with information about what I’m thinking", "4/#ans")
			.addAnswerOption("by dissociating and/or getting angry", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When my partner or good friend is angry or upset with me, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("sometimes pursue them to work it out, sometimes leave the person alone, and I decide based, at least in part, on what that person has told me is wanted.", "4/#ans")
			.addAnswerOption("become even more angry or upset, can’t leave the person alone and/or can’t be calm until that person is also calm", "4/#ans")
			.addAnswerOption("always leave my partner or good friend alone to work it out", "4/#ans")
			.addAnswerOption("try to reach my partner or good friend and then if it doesn't work I dissociate and/or become angry or hopeless and/or try to do anything to soothe them and have their warmth again.", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When my partner or good friend threatens to leave me or talks about thinking about splitting up, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("listen carefully and express what’s alive for me.", "4/#ans")
			.addAnswerOption("panic and maybe even melt down with the threatened abandonment", "4/#ans")
			.addAnswerOption("ignore my partner or friend until things are calm again.", "4/#ans")
			.addAnswerOption("lash out with emotional or physical violence, can become very controlling, and/or I dissociate.", "4/#ans")
	).addElement(
		new FormElementCheckboxes("In my important relationships:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("I have a sense of an inherent balance between giving and receiving", "4/#ans")
			.addAnswerOption("I always give more than I receive", "4/#ans")
			.addAnswerOption("my partner says I take more than I give", "4/#ans")
			.addAnswerOption("I swing intensely between giving and taking", "4/#ans")
	).addElement(
		new FormElementCheckboxes("When my partner/friend or I travel separately or spend time apart from each other, I:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("enjoy my alone time and stay connected and committed with my partner via text, email, or phone calls. If it is a committed partnership, and monogamy is our shared intention, it is easy for me. If polyamory is our shared intention, I remain committed to our agreements", "4/#ans")
			.addAnswerOption("struggle with feelings of abandonment and aloneness", "4/#ans")
			.addAnswerOption("don’t have much contact with my partner or good friend while we’re apart. Sometimes the separation is very relieving or pleasurable", "4/#ans")
			.addAnswerOption("forget my partner or friend exists. If the partnership is sexually intimate, I can enjoy connections (sometimes sexual) with old friends or strangers that my partner would not consent to if my partner knew about them and/or I may experience jealousy, despair, depression, suicidality, or extreme anxiety", "4/#ans")
	).addElement(
		new FormElementCheckboxes("My sexual relationship with my partner is:", true)
			.clearOptions()
			.setDescription("Choose one answer. If you are split, choose all that apply.")
			.addAnswerOption("mutually satisfying or we’ve decided together not to be sexual. I know this because we have conversations about it where both of us express what is true for us", "4/#ans")
			.addAnswerOption("sometimes good and sometimes not satisfying— I often want my partner to be more engaged and present", "4/#ans")
			.addAnswerOption(" satisfying for me ", "4/#ans")
			.addAnswerOption("unpredictable. Sometimes I’m prone to flashbacks and dissociation, and sometimes I don’t realize my partner is actually my partner. ", "4/#ans")
		// .addAnswerOption(" I am not sexual and/or don’t want to answer this question.", "0")
	)
	// 	.addElement(
	// 	new FormElementCheckboxes("My sexual relationship with my partner is:", true)
	// 		.clearOptions()
	// 		.setDescription("Choose one answer. If you are split, choose all that apply.")
	// 		.addAnswerOption("mutually satisfying or we’ve decided together not to be sexual. I know this because we have conversations about it where both of us express what is true for us", "4/#ans")
	// 		.addAnswerOption("sometimes good and sometimes not satisfying— I often want my partner to be more engaged and present", "4/#ans")
	// 		.addAnswerOption(" satisfying for me ", "4/#ans")
	// 		.addAnswerOption("unpredictable. Sometimes I’m prone to flashbacks and dissociation, and sometimes I don’t realize my partner is actually my partner. ", "4/#ans")
	// )

	//https://sarahpeyton.com/attachment-quiz-redirect/
	// Your complete Attachment Style Report is on the way to your email inbox.
	// (ps: I’ve included my free Resonant Guide to Attachment; check your spam folder if you don’t find the email!)
	// Whatever your results are, you make sense. Each attachment style you have was formed based on your experiences with the people closest to you and depend on your lived experiences. Insecure attachment styles are not bad.  Your attachment style percentages reveal your brain’s patterning in relationships with those you are close to, and can point you toward healing!
	// 	The best news? Our brains can change, through the magic of neuroplasticity, and this also changes the way we are with others and allows us to have more fulfilling relationships. This movement toward earned secure attachment is exactly what resonance supports. After stepping into the world of resonance, come back and retake the quiz to see how your brain is changing.
	// 	If you’d like to dive deeper into working with your attachment patterns, consider these webinars and courses:



	attachmentQuizFormItem = form
}

setupForms()


